var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHub(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16349",
    "data-name": "Group 16349",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 29.5,
    cy: 29.5,
    r: 29.5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_2_-_Outline",
    "data-name": "Ellipse 2 - Outline",
    d: "M29.5,0A29.5,29.5,0,1,0,59,29.5,29.5,29.5,0,0,0,29.5,0m0-3A32.491,32.491,0,0,1,52.481,52.481,32.5,32.5,0,1,1,16.849-.445,32.3,32.3,0,0,1,29.5-3Z",
    fill: "#00101f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16356",
    "data-name": "Group 16356",
    transform: "translate(18.754 15.254)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12038",
    "data-name": "Path 12038",
    d: "M4.9,5.788a.889.889,0,0,1,.89-.89H8.459a.889.889,0,0,1,.89.89V8.459a.889.889,0,0,1-.89.89H5.788a.889.889,0,0,1-.89-.89ZM15.582,4.9a.889.889,0,0,1,.89.89V8.459a.889.889,0,0,1-.89.89H12.911a.889.889,0,0,1-.89-.89V5.788a.889.889,0,0,1,.89-.89ZM4.9,12.911a.889.889,0,0,1,.89-.89H8.459a.889.889,0,0,1,.89.89v2.671a.889.889,0,0,1-.89.89H5.788a.889.889,0,0,1-.89-.89Zm10.685-.89a.889.889,0,0,1,.89.89v2.671a.889.889,0,0,1-.89.89H12.911a.889.889,0,0,1-.89-.89V12.911a.889.889,0,0,1,.89-.89ZM0,3.562A3.564,3.564,0,0,1,3.562,0H17.808A3.564,3.564,0,0,1,21.37,3.562v21.37a3.564,3.564,0,0,1-3.562,3.562H3.562A3.564,3.564,0,0,1,0,24.931Zm2.671,0v21.37a.889.889,0,0,0,.89.89H8.014V22.26a2.671,2.671,0,0,1,5.342,0v3.562h4.452a.889.889,0,0,0,.89-.89V3.562a.889.889,0,0,0-.89-.89H3.562A.889.889,0,0,0,2.671,3.562Z",
    fill: "#1a00e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12039",
    "data-name": "Path 12039",
    d: "M0,0H28.493V28.493H0Z",
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHub);
export default __webpack_public_path__ + "static/media/hub.4b6679f3d0483cf6147e52d4e377d07d.svg";
export { ForwardRef as ReactComponent };